import type { GameFactory } from "../core/types";
import type { GameId } from "../shared/catalog";
import { CorridorZeroGame } from "./corridor-zero";
import { DdosBastionGame } from "./ddos-bastion";
import { LatencyLeagueGame } from "./latency-league";
import { OneClientRiderGame } from "./one-client-rider";
import { PacketPilotGame } from "./packet-pilot";
import { PayloadRunnerGame } from "./payload-runner";
import { PhishQuestGame } from "./phish-quest";
import { RogueAppCityGame } from "./rogue-app-city";
import { Sector403Game } from "./sector-403";
import { StackAndBlockGame } from "./stack-and-block";

const gameFactories: Partial<Record<GameId, GameFactory>> = {
  "stack-and-block": (services) => new StackAndBlockGame(services),
  "payload-runner": (services) => new PayloadRunnerGame(services),
  "corridor-zero": (services) => new CorridorZeroGame(services),
  "rogue-app-city": (services) => new RogueAppCityGame(services),
  "latency-league": (services) => new LatencyLeagueGame(services),
  "sector-403": (services) => new Sector403Game(services),
  "one-client-rider": (services) => new OneClientRiderGame(services),
  "packet-pilot": (services) => new PacketPilotGame(services),
  "phish-quest": (services) => new PhishQuestGame(services),
  "ddos-bastion": (services) => new DdosBastionGame(services),
};

export function getGameFactory(gameId: GameId): GameFactory | undefined {
  return gameFactories[gameId];
}
